import { render, staticRenderFns } from "./ExcDropdownTriangle.vue?vue&type=template&id=1c9e23f9&scoped=true&"
import script from "./ExcDropdownTriangle.vue?vue&type=script&lang=ts&"
export * from "./ExcDropdownTriangle.vue?vue&type=script&lang=ts&"
import style0 from "./ExcDropdownTriangle.vue?vue&type=style&index=0&id=1c9e23f9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c9e23f9",
  null
  
)

export default component.exports